import React from 'react';
import { Text, TextMessage } from 'components/tt-forms/common';
import { ContainerFileDinhKem } from 'components/upload';

class LanhDaoGiaoViecTTXM extends React.Component {

  render() {

    return (
      <div className="items-form">
        <div className="row pl10 pr10">
          <Text
            className="col-input"
            label="Phòng ban:"
            value={this.props.thongTinXuLyGiaiQuyet.phongBanGiaiQuyetInfo ?
              this.props.thongTinXuLyGiaiQuyet.phongBanGiaiQuyetInfo.ten : ''} />
          <Text
            className="col-input"
            label="Công chức giải quyết:"
            value={this.props.thongTinXuLyGiaiQuyet.canBoXuLyChiDinhInfo ?
              this.props.thongTinXuLyGiaiQuyet.canBoXuLyChiDinhInfo.hoVaTen : ''} />
        </div>
        <div className="row pl10 pr10">
          <TextMessage
            className="ccol-12"
            value={this.props.thongTinXuLyGiaiQuyet.yKienGiaiQuyet ? this.props.thongTinXuLyGiaiQuyet.yKienGiaiQuyet : ''}
            label='Ghi chú:' />
        </div>
        <div className="container-filedinhkem mt15">
          <ContainerFileDinhKem label="Danh sách văn bản xử lý" disableAttachFile={true} bindValidator={this} dataShow={this.props.listTaiLieuVanThuGiaiQuyetDon} />
        </div>
      </div>
    )
  }
}

export default LanhDaoGiaoViecTTXM;


// WEBPACK FOOTER //
// ./src/components/modules/handle-letters/xu-ly-don/form-giai-quyet/lanh-dao/LanhDaoGiaoViecTTXMView.jsx